import { render, staticRenderFns } from "./muokkaa-seurantajaksoa-container.vue?vue&type=template&id=60e116b9&scoped=true&"
import script from "./muokkaa-seurantajaksoa-container.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-seurantajaksoa-container.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-seurantajaksoa-container.vue?vue&type=style&index=0&id=60e116b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e116b9",
  null
  
)

export default component.exports